import { useStore } from "@nanostores/react";
import { PropsWithChildren, ReactElement, ReactNode, useState } from "react";

import {
  AI_ASSISTANT_GUTTER_WIDTH,
  AI_ASSISTANT_WIDTH,
} from "../../constants/layout.ts";
import { $isCopilotOpen } from "../../stores/copilot.ts";
import { MobileSidebar } from "./MobileSidebar";
import { NavbarItem } from "./NavbarItem";
import { OpenMenuIcon } from "./OpenMenuIcon";

export const StackedLayout = ({
  children,
  navbar,
  sidebar,
}: PropsWithChildren<{
  navbar: ReactNode;
  sidebar: ReactNode;
}>): ReactElement => {
  const [showSidebar, setShowSidebar] = useState(false);
  const isCopilotOpen = useStore($isCopilotOpen);

  return (
    <div
      className="relative isolate flex min-h-svh w-full flex-col bg-white transition-all duration-300 ease-in-out lg:bg-zinc-100 dark:bg-zinc-900 dark:lg:bg-zinc-950"
      style={{
        width: `calc(100% - ${
          isCopilotOpen ? AI_ASSISTANT_WIDTH : AI_ASSISTANT_GUTTER_WIDTH
        }px)`,
      }}
    >
      <MobileSidebar close={() => setShowSidebar(false)} open={showSidebar}>
        {sidebar}
      </MobileSidebar>

      <header className="flex h-14 shrink-0 items-center border-b border-zinc-950/5 bg-white px-4 dark:border-white/10 dark:bg-zinc-900">
        <div className="py-2.5 lg:hidden">
          <NavbarItem
            aria-label="Open navigation"
            onClick={() => setShowSidebar(true)}
          >
            <OpenMenuIcon />
          </NavbarItem>
        </div>
        <div className="flex w-full items-center justify-between">{navbar}</div>
      </header>

      <div className="flex flex-1 overflow-hidden">
        <main className="flex-1 overflow-y-auto bg-white dark:bg-zinc-900">
          <div className="h-full p-6 lg:rounded-lg lg:bg-transparent lg:p-10">
            <div className="mx-auto h-full max-w-6xl">{children}</div>
          </div>
        </main>
      </div>
    </div>
  );
};
